import React from 'react';
import {
  Popover,
  Box,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';

interface EmailSummary {
  loading?: boolean;
  error?: string | null;
  summary?: string;
}

interface EmailSummaryPopoverProps {
  anchorEl: { element: HTMLElement; eventId: string } | null;
  emailSummaries: { [eventId: string]: EmailSummary };
  onClose: () => void;
}

export const EmailSummaryPopover: React.FC<EmailSummaryPopoverProps> = ({
  anchorEl,
  emailSummaries,
  onClose,
}) => {
  const eventId = anchorEl?.eventId;
  const summary = eventId ? emailSummaries[eventId] : null;

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl?.element}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      PaperProps={{
        sx: { maxWidth: 500, minWidth: 300 }
      }}
    >
      <Box sx={{ p: 2 }}>
        {summary?.loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={20} />
            <Typography variant="body2" color="text.secondary">
              Generating summary...
            </Typography>
          </Box>
        ) : summary?.error ? (
          <Alert severity="error" sx={{ py: 0 }}>
            {summary.error}
          </Alert>
        ) : summary?.summary ? (
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 600, color: 'primary.main', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 1 }}>
              Summary by Eliot
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
              {summary.summary}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Loading...
          </Typography>
        )}
      </Box>
    </Popover>
  );
};
